import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { LazyComponent } from '../../../components/LazyComponents';

const AdBlockPageLazy = React.lazy(() => import('./AdBlockPage'));

export function LazyAdBlockPage(props: RouteComponentProps) {
  return <LazyComponent lazyComponent={<AdBlockPageLazy {...props} />} />;
}
